import { render, staticRenderFns } from "./DisplayAmount.vue?vue&type=template&id=1fa33038&scoped=true&"
import script from "./DisplayAmount.vue?vue&type=script&lang=js&"
export * from "./DisplayAmount.vue?vue&type=script&lang=js&"
import style0 from "./DisplayAmount.vue?vue&type=style&index=0&id=1fa33038&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa33038",
  null
  
)

export default component.exports